import React from "react";
import "./Card.css";

const Card = ({
  customerName,
  address,
  assignee,
  status,
  onCancel,
  onEdit,
  date,
  hideButtons = false // Default to false if not provided
}) => {
  const statusColors = {
    "In-Progress": "#FFA500", // Orange
    "Not Started": "#4CAF50", // Green
    Completed: "#2196F3", // Blue
    Cancelled: "#F44336", // Red
  };

  const isDisabled = status === "In-Progress" || status === "Completed" || status === "Cancelled";

  const borderColor = statusColors[status];

  // Create a safe CSS class name from status
  const statusClass = status.replace(/\s+/g, '-').toLowerCase();

  return (
    <div className={`card ${statusClass}`} style={{ borderColor }}>
      {/* Green icon box with note/checklist symbol */}
      <div
        className="card-icon"
        style={{ backgroundColor: borderColor }} // Match background to border color
      >
        <div className="note-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="white"
            width="20px"
            height="20px"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM12 3c.55 0 1 .45 1 1h-2c0-.55.45-1 1-1zm7 18H5V5h14v16zm-6-9H7v2h6v-2zm4 4H7v2h10v-2z" />
          </svg>
        </div>
      </div>

      {/* Card details */}
      <div className="card-details">
        <h4>Customer: {customerName}</h4>
        <p>Address: {address}</p>
        <p>Assigned To: {assignee}</p>
        <p>Date: {date}</p>
      </div>

     
      {!hideButtons && (
        <div className="card-button-group">
          <button className="edit-button" onClick={onEdit} disabled={isDisabled}>Edit</button>
          <button className="cancel-button" onClick={onCancel} disabled={isDisabled}>Cancel</button>
        </div>
      )}
    </div>
  );
};

export default Card;